import { Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import Container from "../../components/utils/Container";
import LazyLoadImg from "../../components/elements/images/LazyLoadImg";
import Paragraph from "../../components/elements/p/Paragraph";
import ButtonHref from "../../components/elements/buttons/ButtonHref";
import Icon from "../../components/elements/icons/Icon";
import LoadeDetailProductBox from "../../components/utils/loadersBox/LoadeDetailProductBox";
import {
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
  FaFacebook,
} from "react-icons/fa";

import {
  shareOnFacebook,
  shareOnLinkedIn,
  shareOnWhatsapp,
  shareOnTwitter,
} from "../../functions/social";

const BodyDetailProduct = ({ product, error, loading }) => {
  //format the date
  function formatDateToFrancFormat(dateMilliseconds) {
    const date = new Date(dateMilliseconds);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return loading ? (
    <Container>
      <LoadeDetailProductBox classe="mt-[140px] md:mt-[200px]" />
    </Container>
  ) : error ? (
    <span className="font-nunito text-sm text-[#fc3838]">{error && error}</span>
  ) : (
    <Container classe="mt-[140px] md:mt-[200px] md:flex md:flex-row md:items-center md:space-x-32">
      <div className="flex shrink-0 flex-col items-start justify-start space-y-10 md:space-y-16">
        <Link
          to="/produits"
          className="animate flex items-center space-x-1 hover:text-primary"
        >
          <BsArrowLeft />
          <Paragraph size="small"> Tous les articles</Paragraph>
        </Link>
        <div className="h-92 mt-5 w-64 flex-none sm:w-72 md:w-[300px] lg:w-[400px]">
          <LazyLoadImg
            img={product.getImage}
            alt="Ordinateur portable dell"
            classe="detaiProductImg"
          />
        </div>
        <ButtonHref
          target="_blank"
          size="small"
          href="https://wa.me/237674651112"
        >
          Contacter le vendeur
        </ButtonHref>
      </div>
      <section className="mt-8 flex flex-col space-y-3 md:mt-0">
        <div className="">
          <span className="inline-block font-nunito text-base font-semibold text-secondary underline md:text-lg  md:font-semibold">
            Prix de l'article
          </span>
          <div className="mt-1 flex items-center space-x-2">
            <span className="font-nunito text-lg font-bold text-primary md:text-2xl">
              {product.getPrise + " fcfa"}
            </span>
            <span className="font-nunito text-sm font-thin line-through">
              {product.getOldPrise + " fcfa"}
            </span>
          </div>
        </div>
        <div className="">
          <span className="inline-block font-nunito text-base font-semibold text-secondary underline md:text-lg md:font-semibold">
            Nom
          </span>
          <Paragraph size="small" classe="mt-1">
            {product.getName}
          </Paragraph>
        </div>

        <div className="">
          <span className="inline-block font-nunito text-base font-semibold text-secondary underline md:text-lg md:font-semibold">
            Caractéristiques
          </span>
          <Paragraph size="small" classe="mt-1">
            {product.getCaracteristics}
          </Paragraph>
        </div>

        <div className="">
          <span className="inline-block font-nunito text-base font-semibold text-secondary underline md:text-lg md:font-semibold">
            Description
          </span>
          <Paragraph size="small" classe="mt-1 max-w-[600px]">
            {product.getDescription}
          </Paragraph>
        </div>

        <div className="">
          <span className="inline-block font-nunito text-base font-semibold text-secondary underline md:text-lg md:font-semibold">
            Date de publication
          </span>
          <Paragraph size="small" classe="mt-1 max-w-[600px]">
            {formatDateToFrancFormat(product.getCreationDate)}
          </Paragraph>
        </div>
        <div className="">
          <span className="inline-block font-nunito text-base font-semibold text-secondary underline md:text-lg md:font-semibold">
            Partager cet article
          </span>
          <div className="my-5 flex items-center space-x-2">
            <Icon
              size="small"
              onShareToNetwork={shareOnWhatsapp}
              linkOfArticleToShare={window.location.href}
            >
              <FaWhatsapp size={200} />
            </Icon>
            <Icon
              size="small"
              onShareToNetwork={shareOnTwitter}
              linkOfArticleToShare={window.location.href}
              articleName={product.getName}
            >
              <FaTwitter size={200} />
            </Icon>
            <Icon
              size="small"
              onShareToNetwork={shareOnFacebook}
              linkOfArticleToShare={window.location.href}
            >
              <FaFacebook size={200} />
            </Icon>
            <Icon
              size="small"
              onShareToNetwork={shareOnLinkedIn}
              linkOfArticleToShare={window.location.href}
            >
              <FaLinkedinIn size={200} />
            </Icon>
          </div>
        </div>
      </section>
    </Container>
  );
};

export default BodyDetailProduct;
